import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable max-classes-per-file */
var KeyboardEventServerSafe = typeof window !== 'undefined' ? window.KeyboardEvent : /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }
  return _createClass(_class);
}();
var MouseEventServerSafe = typeof window !== 'undefined' ? window.MouseEvent : /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
  }
  return _createClass(_class2);
}();
var WheelEventServerSafe = typeof window !== 'undefined' ? window.WheelEvent : /*#__PURE__*/function () {
  function _class3() {
    _classCallCheck(this, _class3);
  }
  return _createClass(_class3);
}();
export var ForwardedKeyboardEvent = /*#__PURE__*/function (_KeyboardEventServerS) {
  _inherits(ForwardedKeyboardEvent, _KeyboardEventServerS);
  var _super = _createSuper(ForwardedKeyboardEvent);
  function ForwardedKeyboardEvent() {
    var _this;
    _classCallCheck(this, ForwardedKeyboardEvent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "forwarded", true);
    return _this;
  }
  return _createClass(ForwardedKeyboardEvent);
}(KeyboardEventServerSafe);
export var ForwardedMouseEvent = /*#__PURE__*/function (_MouseEventServerSafe) {
  _inherits(ForwardedMouseEvent, _MouseEventServerSafe);
  var _super2 = _createSuper(ForwardedMouseEvent);
  function ForwardedMouseEvent() {
    var _this2;
    _classCallCheck(this, ForwardedMouseEvent);
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this2), "forwarded", true);
    return _this2;
  }
  return _createClass(ForwardedMouseEvent);
}(MouseEventServerSafe);
export var ForwardedWheelEvent = /*#__PURE__*/function (_WheelEventServerSafe) {
  _inherits(ForwardedWheelEvent, _WheelEventServerSafe);
  var _super3 = _createSuper(ForwardedWheelEvent);
  function ForwardedWheelEvent() {
    var _this3;
    _classCallCheck(this, ForwardedWheelEvent);
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    _this3 = _super3.call.apply(_super3, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this3), "forwarded", true);
    return _this3;
  }
  return _createClass(ForwardedWheelEvent);
}(WheelEventServerSafe);